import { useState } from "react";
import { useForgotPasswordMutation } from "../api/passwordRecoveryApi";
import { getForgotPasswordError } from "./getForgotPasswordError";

interface UseForgotPasswordResult {
  email: string;
  setEmail: (email: string) => void;
  submit: () => void;
  isSubmitting: boolean;
  errorMessage: string | null;
  isSent: boolean;
}

export const useForgotPassword = (): UseForgotPasswordResult => {
  const [email, setEmail] = useState("");
  const [forgotPassword, { isLoading, error, isSuccess }] =
    useForgotPasswordMutation();

  const submit = async () => {
    if (!email.trim()) return;
    try {
      await forgotPassword({ email: email.trim() }).unwrap();
    } catch {
      // error surfaced via mutation state below
    }
  };

  return {
    email,
    setEmail,
    submit,
    isSubmitting: isLoading,
    errorMessage: getForgotPasswordError(error),
    isSent: isSuccess,
  };
};
